import { useCallback, useEffect } from "react";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useDocumentParams } from "../useDocumentParams";

export enum FinancialDocumentDetailsView {
    DEFAULT = "default",
    MATCHING = "matching",
}

export function usePathBasedFinancialDocumentDetailsView() {
    const navigate = useStateAwareNavigate();
    const { view, documentId } = useDocumentParams();

    let currentView = FinancialDocumentDetailsView.DEFAULT;

    if (view?.toLowerCase() === "matching") {
        currentView = FinancialDocumentDetailsView.MATCHING;
    }

    useEffect(() => {
        if (currentView === FinancialDocumentDetailsView.DEFAULT) {
            navigate(`/documents/${documentId}`, { replace: true });
        }
    }, [currentView, documentId, navigate]);

    const go = useCallback(
        (newView?: FinancialDocumentDetailsView) => {
            navigate(`/documents/${documentId}/${newView}`);
        },
        [documentId, navigate],
    );

    return {
        currentView,
        go,
    };
}
